module.exports = __webpack_public_path__ + "img/img6.09866e2a.png";